import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-gray-200 shadow-lg px-4 py-3 md:py-4 safe-area-bottom" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-xs text-gray-600 flex-1 leading-relaxed">
          Utilizamos cookies para melhorar sua experiência, analisar o tráfego do site e personalizar conteúdo.
          Ao continuar navegando, você concorda com nossa{' '}
          <a href="/privacidade" className="text-blue-600 underline">Política de Privacidade</a>.
        </p>
        <button
          onClick={accept}
          className="px-5 py-2 bg-[#2563eb] text-white text-xs font-semibold rounded-lg hover:bg-[#1d4ed8] transition-colors whitespace-nowrap flex-shrink-0"
          data-testid="cookie-accept-btn"
        >
          Aceitar
        </button>
      </div>
    </div>
  );
}
